// removed by extract-text-webpack-plugin
module.exports = {"text":"onfido-sdk-ui-Welcome-text"};


//////////////////
// WEBPACK FOOTER
// ./components/Welcome/style.css
// module id = 388
// module chunks = 1